//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ClientListConfig
export const OutstandingLiabilitiesConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/bankRec/outstandingLiabilities",
      component: FuseLoadable({
        loader: () => import("./OutstandingLiabilities.js")
      })
    }
  ]
  //end routes
};
